import { getInstance } from '../../../lib/axios';
import constants from '../../../constants';

export async function getAllWorkouts() {
  try {
    const url = `${constants.endpoints.CUSTOM_TRAININGS}/workouts`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Fetch all workouts failed', error.message);
    throw error;
  }
}

export async function createCustomTraining(data) {
  try {
    const response = await getInstance().post(constants.endpoints.CUSTOM_TRAININGS, data);
    return response.data;
  } catch (error) {
    console.error('Create custom training failed', error.message);
    throw error;
  }
}

export async function getCustomTrainings(userId) {
  try {
    const url = `${constants.endpoints.CUSTOM_TRAININGS}/customTrainings/${userId}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Fetch custom trainings failed', error.message);
    throw error;
  }
}

export async function deleteCustomTraining(trainingId) {
  try {
    const url = `${constants.endpoints.CUSTOM_TRAININGS}/customTraining`;
    const response = await getInstance().delete(url, { params: { trainingId } });
    return response.data;
  } catch (error) {
    console.error('Delete custom training failed', error.message);
    throw error;
  }
}